import { TipologicaSole24Ore } from "./tipologiche-sole-24-ore";

export class Sole24OreRequest {
    fonte: string;
    searchText: string;
    dataDa: number;
    dataA: number;
    numero: number;
    articolo: number;
    bis: string;
    provvedimento: TipologicaSole24Ore; //tipologica
    ambito: TipologicaSole24Ore; //tipologica
    organo: TipologicaSole24Ore; //tipologica
    size: number;
    fromResult: number;

    constructor(){
        this.fonte = null;
        this.searchText = null;
        this.dataDa = new Date(new Date().getFullYear(), 0, 1).getTime();;
        this.dataA = new Date().getTime();
        this.numero = null;
        this.articolo = null;
        //this.bis = null;
        this.provvedimento = null;
        //this.ambito = null;
        this.organo = null;
        this.size = 20;
        this.fromResult = null;
    }
}